const hexToRgb = (hex: string): number[] => {
  hex = hex.replace(/[^0-9A-F]/gi, "");
  const bigint = parseInt(hex, 16);
  return [((bigint >> 16) & 255) / 255, ((bigint >> 8) & 255) / 255, (bigint & 255) / 255];
};

const getLuminance = (color: string): number => {
  const lin = (v: number) => (v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4));
  const rgb = hexToRgb(color);
  const components = rgb.map(lin);
  return 0.2126 * components[0] + 0.7152 * components[1] + 0.0722 * components[2];
};

export const getContrastRatio = (color1: string, color2: string): number => {
  const lum1 = getLuminance(color1);
  const lum2 = getLuminance(color2);
  if (lum1 > lum2) {
    return (lum1 + 0.05) / (lum2 + 0.05);
  }
  return (lum2 + 0.05) / (lum1 + 0.05);
};

export const chooseBestContrast = (color: string, choices: string[]) => {
  const ratios = choices.map((x) => getContrastRatio(color, x));
  const argMax = ratios.map((x, i) => [x, i]).reduce((r, a) => (a[0] > r[0] ? a : r))[1];
  return choices[argMax];
};

export const bestColor = (
  colors: string[],
  lightColor: string = "#ffffff",
  darkColor: string = "#010016",
) => (1.05 / (getLuminance(colors[0]) + 0.05) > 4.5 ? lightColor : darkColor);
